import { breakpoints } from '../../core/constants';
import Lenis from 'lenis';
import MenuScrollAnimation from '../../plugins/gsap/menu-scroll-animation';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

class Menu {
    config = {
        openClass: 'is-open',
        headerNavElement: '[data-menu-container]',
        headerContent: '.menu-container__content',
        navClass: 'nav',
        navItemClass: 'nav__item',
        navLinkClass: 'nav__link',
        navItemParentClass: 'nav__item--parent',
        hamburgerElement: '[data-menu-toggler]',
    };

    constructor(menu, config = {}) {
        if (!menu) return;

        this.menu = menu;
        this.config = {...this.config, ...config};
        this.animation = new MenuScrollAnimation(this.config.headerNavElement);

        this.init();

        if (window.matchMedia(`(min-width: ${breakpoints.lg}px)`).matches) {
            this.animation.init();

            const menuLenis = new Lenis({
                autoRaf: true,
                duration: 0.6,
                wrapper: document.querySelector(this.config.headerNavElement),
                content: document.querySelector(this.config.headerContent),
                infinite: true,
                syncTouch: true,
            });

            menuLenis.on('scroll', ScrollTrigger.update);
        }
    }

    init() {
        this.registerEvents();
    }

    registerEvents() {
        this.select(this.config.hamburgerElement).addEventListener('click', this.hamburgerToggle.bind(this));
        this.select(`${this.config.headerNavElement}`).addEventListener('transitionend', () => {
            if (window.matchMedia(`(min-width: ${breakpoints.lg}px)`).matches) {
                this.animation.setupScrollTrigger();
            }
        });
    }

    hamburgerToggle() {
        const hamburger = this.select(`${this.config.hamburgerElement}`);
        const headerNavElement = this.select(`${this.config.headerNavElement}`);

        headerNavElement.scrollTop = 0;

        headerNavElement.classList.toggle(this.config.openClass);
        hamburger.classList.toggle(this.config.openClass);

        if (hamburger.classList.contains(this.config.openClass)) {
            hamburger.textContent = hamburger.getAttribute('data-close-text');
            document.documentElement.style.overflow = 'hidden';
        } else {
            hamburger.textContent = hamburger.getAttribute('data-open-text');
            document.documentElement.style.overflow = '';
        }
    }

    select(elem) {
        return document.querySelector(elem) ? document.querySelector(elem) : null;
    }

    selectAll(elem) {
        return document.querySelectorAll(elem) ? [...document.querySelectorAll(elem)] : null;
    }
}

new Menu(document.querySelector('[data-menu-container]'));
